/**
 * Calculate ARPU (Average Revenue Per User) - средний доход от одного пользователя
 * ARPU = total revenue / subscribers count
 */
export const calculateArpu = (revenue: number, subscribers: number): number => {
  if (subscribers <= 0) return 0;
  return revenue / subscribers;
};

/**
 * Calculate ARPD (Average Revenue Per Day) - доход за день на количество активных пользователей в этот день
 * ARPD = revenue / (active users count * days)
 * For now, we'll use subscribers as active users and calculate days from campaign start
 */
export const calculateArpd = (revenue: number, subscribers: number, startDate: string): number => {
  if (subscribers <= 0) return 0;

  const start = new Date(startDate);
  const now = new Date();
  const daysDiff = Math.max(
    1,
    Math.ceil((now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
  );

  return revenue / (subscribers * daysDiff);
};

/**
 * Calculate ARPU (w) - средний доход от одного пользователя за неделю
 * ARPU (w) = revenue / (subscribers * weeks)
 */
export const calculateArpuWeek = (
  revenue: number,
  subscribers: number,
  startDate: string
): number => {
  if (subscribers <= 0) return 0;

  const start = new Date(startDate);
  const now = new Date();
  const daysDiff = Math.max(
    1,
    Math.ceil((now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
  );
  const weeks = Math.max(1, Math.ceil(daysDiff / 7));

  return revenue / (subscribers * weeks);
};

/**
 * Calculate ARPU (m) - средний доход от одного пользователя за месяц
 * ARPU (m) = revenue / (subscribers * months)
 */
export const calculateArpuMonth = (
  revenue: number,
  subscribers: number,
  startDate: string
): number => {
  if (subscribers <= 0) return 0;

  const start = new Date(startDate);
  const now = new Date();
  const daysDiff = Math.max(
    1,
    Math.ceil((now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
  );
  const months = Math.max(1, Math.ceil(daysDiff / 30));

  return revenue / (subscribers * months);
};

/**
 * Calculate ARPU (a) - средний доход от одного пользователя за год
 * ARPU (a) = revenue / (subscribers * years)
 */
export const calculateArpuYear = (
  revenue: number,
  subscribers: number,
  startDate: string
): number => {
  if (subscribers <= 0) return 0;

  const start = new Date(startDate);
  const now = new Date();
  const daysDiff = Math.max(
    1,
    Math.ceil((now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
  );
  const years = Math.max(1, Math.ceil(daysDiff / 365));

  return revenue / (subscribers * years);
};

/**
 * Calculate ARPU ($) - средний доход от одного пользователя за весь период
 * ARPU ($) = revenue / subscribers (same as basic ARPU)
 */
export const calculateArpuTotal = (revenue: number, subscribers: number): number => {
  return calculateArpu(revenue, subscribers);
};
